import { render, staticRenderFns } from "./fab-registro-incidente.vue?vue&type=template&id=ab67ade8&"
import script from "./fab-registro-incidente.vue?vue&type=script&lang=js&"
export * from "./fab-registro-incidente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports